import { useCallback } from 'react'
import { matchPath } from 'react-router'

export const useFindRouteMatch = () => {
  return useCallback((routes: any, pathname: string) => {
    if (!pathname) { return null }
    const keys: any = Object.keys(routes)
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]
      const path = routes[key].path
      const match = matchPath({
        path: path,
      }, pathname)
      if (match) {
        return {
          routeName: key,
          match,
        }
      }
    }
  }, [])
}
